var regex = /^(:|\[|>|&)/;

export default function isNestedSelector(property) {
  return regex.test(property);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/isNestedSelector.js
// module id = 729
// module chunks = 0